import "@expo/metro-runtime";
import "./polyfills";
import * as Sentry from "@sentry/react-native";

import "react-native-gesture-handler";
import "./src/OS/bootstrap";
import { LogBox } from "react-native";
import { enableScreens, enableFreeze } from "react-native-screens";
import { OS } from "./src/OS";
import { config } from "./src/config";
import { registerRootComponent } from "expo";
import {
  configureReanimatedLogger,
  ReanimatedLogLevel,
} from "react-native-reanimated";

configureReanimatedLogger({
  level: ReanimatedLogLevel.warn,
  strict: false,
});

LogBox.ignoreLogs([
  "ViewPropTypes will be removed",
  "ColorPropType will be removed",
]);

enableScreens(true);
enableFreeze(true);

if (__DEV__) {
  console.log("--------- LAUNCH ---------");
}

Sentry.init({
  dsn: "https://0a5ebc938d14c6bb1fb00d2c2b94b8d4@o4507135394185216.ingest.de.sentry.io/4508756158840912",
  enableAutoSessionTracking: true,
  environment: config.name,
  sessionTrackingIntervalMillis: 20000,
  attachThreads: true,
  enabled: !__DEV__,
  sendDefaultPii: true,
  attachViewHierarchy: true,
  attachStacktrace: true,
  replaysSessionSampleRate: 0,
  replaysOnErrorSampleRate: 0.1,
  integrations: [
    Sentry.mobileReplayIntegration(),
    Sentry.expoContextIntegration(),
  ],
  spotlight: __DEV__,
});

// registerRootComponent calls AppRegistry.registerComponent('main', () => App);
// It also ensures that whether you load the app in the Expo client or in a native build,
// the environment is set up appropriately
registerRootComponent(OS);
